//  https://github.com/pangolindex/interface/blob/master/src/state/stake/hooks.ts

const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  WETH_WAVAX: "0x7c05d54fc5cb6e4ad87c6f5db3b807c94bb89c52"
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WETH_WAVAX]: "0x830a966b9b447c9b15ab24c0369c4018e75f31c9"
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WETH_WAVAX]: 2
};

module.exports = {
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH
};
